import type { AdditionalExpensesItemProps } from '@pages/OtherExpenses/context/types'

export const setInitialValues = (data: AdditionalExpensesItemProps) => {
  return {
    accountNumber: data.accountingCode || '',
    accountDescription: data.accountingCode || '',
    accountDescriptionText: data.accountingDescription || '',
    additionalExpensesValue: data.value?.toFixed(2) || '',
    observations: data.observations || ''
  }
}
